import { render, staticRenderFns } from "./QrCode.vue?vue&type=template&id=cc540a14&scoped=true&"
import script from "./QrCode.vue?vue&type=script&lang=ts&"
export * from "./QrCode.vue?vue&type=script&lang=ts&"
import style0 from "./QrCode.vue?vue&type=style&index=0&id=cc540a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc540a14",
  null
  
)

export default component.exports